import {
  formatActiveLoanNavbarLabel,
  formatLoanDropdownLabel,
  loansMatch,
} from "../utils/utility-functions";

export const ActiveLoanNavbarLabel = ({
  activeLoan,
  loans,
  activeLoanDetails,
}) => {
  return formatActiveLoanNavbarLabel(activeLoan, loans, activeLoanDetails);
};

export const LoanDropdownItemLabel = ({
  loan,
  activeLoan,
  activeLoanDetails,
}) => {
  const detailsContext = loansMatch(loan, activeLoan)
    ? activeLoanDetails
    : null;
  return formatLoanDropdownLabel(loan, detailsContext);
};
